import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { DraftGroup, IMatchupsResponse, IOptimizerState, IShopOutcome, IShopOutcomesPagination, IToolFilters, Leagues, OptimizerData, OptimizerEntry } from './types';

const initialState = {
  wager:10,
  operator: 'pick6',
  filters: {
    league: 'MLB',
  } as IToolFilters,
  optimizerState: {
    matchups: [],
    matchupsFilter: [],
    offersFilter: [],
    entries: [],
    gridpaginationModel : {
      page: 0,
      pageSize: 25
    },
    selectedEntry: 0,
    additionalLegs: {} as any,
    isEntryView: false,
    optimizerData: [],
    selectedDraftGroup:{} as DraftGroup,
    maxLegs: 10,
  } as IOptimizerState,
}

const pick6Slice = createSlice({
  name: 'pick6',
  initialState,
  reducers: {
    setSelectedDraftGroup: (state, action: PayloadAction<DraftGroup>) => {
      state.optimizerState.selectedDraftGroup= action.payload;
    },
    setWager: (state, action: PayloadAction<number>) => {
      state.wager = action.payload
    },
    setIsEntryView: (state, action: PayloadAction<boolean>) => {
      state.optimizerState.isEntryView = action.payload
    },
    setLeagueFilter: (state, action: PayloadAction<Leagues>) => {
      state.filters.league = action.payload
    },
    setMaxLegs: (state, action: PayloadAction<number>) => {
      state.optimizerState.maxLegs = action.payload;
    },
    addOptimizerData: (state, action: PayloadAction<OptimizerData>) => {
      state.optimizerState.optimizerData = [...state.optimizerState.optimizerData, action.payload];
    },
    clearMatchupsFilter: (state) => {
      state.optimizerState.matchupsFilter = [];
    },
    setOfferFilters: (state, action: PayloadAction<string[]>) => {
      state.optimizerState.offersFilter = action.payload;
    },
    addLineupEntry: (state, action: PayloadAction<OptimizerEntry>) => {
      state.optimizerState.entries = [...state.optimizerState.entries, action.payload];
    },
    setSelectedEntry: (state, action: PayloadAction<number>) => {
      state.optimizerState.selectedEntry = action.payload;
    },
    setCurrentEntry: (state, action: PayloadAction<OptimizerEntry>) => {
      let selectedEntry = state.optimizerState.selectedEntry;
      const entryIndex = state.optimizerState.entries.findIndex(x => x.id === selectedEntry);
      state.optimizerState.entries[entryIndex] = action.payload;
    },
    removePickFromEntry: (state, action: PayloadAction<IShopOutcome>) => {
      let selectedEntry = state.optimizerState.selectedEntry;
      state.optimizerState.entries[selectedEntry].outcomes =
        [...state.optimizerState.entries[selectedEntry].outcomes.filter(x => x.outcomeId !== action.payload.outcomeId)];
    },
    removeLineupEntry: (state, action: PayloadAction<OptimizerEntry>) => {
      state.optimizerState.entries =
        [...state.optimizerState.entries.filter(x => x.id !== action.payload.id)]; 
    },
    setAdditionalOptimizerLegs: (state, action: PayloadAction<{
      outcomes: IShopOutcome[];
      pagination: Partial<IShopOutcomesPagination>;
    }>) => {
      state.optimizerState.additionalLegs = action.payload
    },
    setMatchups: (state, action: PayloadAction<IMatchupsResponse[]>) => {
      state.optimizerState.matchups = action.payload;
    },
    setMatchupsFilter: (state, action: PayloadAction<IMatchupsResponse>) => {
      state.optimizerState.matchupsFilter = [...state.optimizerState.matchupsFilter, action.payload];
    },
    removeMatchupsFilter: (state, action: PayloadAction<IMatchupsResponse>) => {
      state.optimizerState.matchupsFilter = [...state.optimizerState.matchupsFilter.filter(x => x.id !== action.payload.id)];
    },
  }
});

export const { 
  setSelectedDraftGroup,
  setWager,
  setIsEntryView,
  setLeagueFilter,
  setMaxLegs,
  addOptimizerData,
  clearMatchupsFilter,
  setOfferFilters,
  addLineupEntry,
  setSelectedEntry,
  setCurrentEntry,
  removePickFromEntry,
  removeLineupEntry,
  setAdditionalOptimizerLegs,
  setMatchups,
  setMatchupsFilter,
  removeMatchupsFilter,
 } = pick6Slice.actions;

export default pick6Slice.reducer;